import { httpClientBanking } from '~/domains/banking/shared/infra/http-client-banking'
import { useQueryRequest } from '~/ui/hooks/utils'

import { type MarketProduct } from './definitions'

async function fetchMarketProductDetails({ productId, accountId }: { productId: string; accountId: string }) {
  const { data } = await httpClientBanking<MarketProduct>({
    url: `/investments/accounts/${accountId}/storefront/offers/${productId}`,
    method: 'GET'
  })

  return data
}

export function useFetchMarketProductDetails({
  productId,
  accountId,
  enabled,
  suspense
}: {
  productId?: string
  accountId: string
  enabled?: boolean
  suspense?: boolean
}) {
  const isEnabled = enabled ?? Boolean(accountId && productId)

  return useQueryRequest<MarketProduct, unknown, true>(
    ['useFetchMarketProductDetails', accountId, productId],
    () => {
      if (!productId) {
        throw new Error('useFetchMarketProductDetails: productId is required')
      }

      return fetchMarketProductDetails({ accountId, productId })
    },
    { enabled: isEnabled, suspense: suspense ?? false }
  )
}
